// frontend/src/pages/MerchantPayPage.jsx
// Static merchant QR pay page: payer enters amount → creates charge → redirect to PublicChargePage
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { staticQrAPI } from '../services/api';

export default function MerchantPayPage() {
  const { merchantCode } = useParams();
  const navigate = useNavigate();
  const [merchant, setMerchant]   = useState(null);
  const [amount, setAmount]       = useState('');
  const [phone, setPhone]         = useState('');
  const [description, setDesc]    = useState('');
  const [loading, setLoading]     = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError]         = useState('');

  useEffect(() => {
    staticQrAPI.getMerchant(merchantCode)
      .then(r => setMerchant(r.merchant))
      .catch(() => setError('Merchant not found.'))
      .finally(() => setLoading(false));
  }, [merchantCode]);

  async function handlePay(e) {
    e.preventDefault();
    setError('');
    if (!amount || Number(amount) < 500) { setError('Minimum amount is UGX 500'); return; }
    setSubmitting(true);
    try {
      const r = await staticQrAPI.createCharge(merchantCode, {
        amount: Math.round(Number(amount)),
        phone: phone || undefined,
        description: description || undefined,
      });
      navigate(r.payUrl);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to create charge. Please try again.');
    } finally {
      setSubmitting(false);
    }
  }

  if (loading) return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'#0f172a' }}>
      <div style={{ color:'#94a3b8', fontSize:16 }}>Loading...</div>
    </div>
  );

  if (error && !merchant) return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'#0f172a' }}>
      <div style={{ background:'#1e293b', padding:32, borderRadius:12, color:'#f87171', textAlign:'center' }}>
        <div style={{ fontSize:40, marginBottom:12 }}>⚠️</div>
        <div>{error}</div>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight:'100vh', background:'#0f172a', display:'flex', alignItems:'center', justifyContent:'center', padding:16 }}>
      <div style={{ background:'#1e293b', borderRadius:16, padding:32, width:'100%', maxWidth:420, boxShadow:'0 20px 60px rgba(0,0,0,0.5)' }}>
        {/* Header */}
        <div style={{ textAlign:'center', marginBottom:28 }}>
          {merchant?.logoUrl
            ? <img src={merchant.logoUrl} alt="logo" style={{ height:56, objectFit:'contain', marginBottom:12 }} />
            : <div style={{ width:56, height:56, borderRadius:28, background:'#1e3a5f', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 12px', fontSize:24 }}>🏪</div>
          }
          <div style={{ color:'#f1f5f9', fontWeight:700, fontSize:20 }}>{merchant?.businessName}</div>
          <div style={{ color:'#64748b', fontSize:13, marginTop:4 }}>Enter payment details below</div>
        </div>

        <form onSubmit={handlePay}>
          {/* Amount */}
          <label style={{ color:'#94a3b8', fontSize:13, display:'block', marginBottom:6 }}>Amount (UGX) *</label>
          <input
            type="number" min="500" step="100"
            value={amount} onChange={e => setAmount(e.target.value)}
            placeholder="e.g. 50000"
            style={{ width:'100%', padding:'12px 14px', borderRadius:8, border:'1px solid #334155', background:'#0f172a', color:'#f1f5f9', fontSize:16, boxSizing:'border-box', marginBottom:14 }}
            required
          />

          {/* Optional description */}
          <label style={{ color:'#94a3b8', fontSize:13, display:'block', marginBottom:6 }}>Description (optional)</label>
          <input
            type="text" value={description} onChange={e => setDesc(e.target.value)}
            placeholder="What is this payment for?"
            style={{ width:'100%', padding:'12px 14px', borderRadius:8, border:'1px solid #334155', background:'#0f172a', color:'#f1f5f9', fontSize:15, boxSizing:'border-box', marginBottom:14 }}
          />

          {/* Optional phone for reference */}
          <label style={{ color:'#94a3b8', fontSize:13, display:'block', marginBottom:6 }}>Your phone (optional)</label>
          <input
            type="tel" value={phone} onChange={e => setPhone(e.target.value)}
            placeholder="07XXXXXXXX"
            style={{ width:'100%', padding:'12px 14px', borderRadius:8, border:'1px solid #334155', background:'#0f172a', color:'#f1f5f9', fontSize:15, boxSizing:'border-box', marginBottom:20 }}
          />

          {error && <div style={{ color:'#f87171', fontSize:13, marginBottom:14, padding:'10px 14px', background:'rgba(239,68,68,0.1)', borderRadius:8 }}>{error}</div>}

          <button
            type="submit" disabled={submitting}
            style={{ width:'100%', padding:'14px', background:submitting ? '#374151':'#0ea5e9', color:'#fff', border:'none', borderRadius:10, fontSize:16, fontWeight:700, cursor:submitting?'not-allowed':'pointer' }}
          >
            {submitting ? 'Creating payment...' : `Pay ${amount ? 'UGX ' + Number(amount).toLocaleString() : 'Now'}`}
          </button>
        </form>

        <div style={{ textAlign:'center', marginTop:20, color:'#475569', fontSize:12 }}>
          Secured by DWI FINTECH (U) LIMITED
        </div>
      </div>
    </div>
  );
}
